import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "environment";
import { getToken } from "helpers";

const getDateRange = () => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(endDate.getDate() - 30);

  return {
    start_date: startDate.toISOString().split("T")[0],
    end_date: endDate.toISOString().split("T")[0],
  };
};

export const reportsApi = createApi({
  reducerPath: "reportsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.dev.baseUrl}/reports/client/manage`,
    prepareHeaders: (headers) => {
      headers.set("authorization-token", getToken() || "");
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getReports: builder.query<any, void>({
      query: () => ({
        url: "/realtime/active",
      }),
      transformErrorResponse: (error: any) => error.data.apierror,
    }),
    getStatistics: builder.query<any, { start_date?: string; end_date?: string }>({
      query: (params = {}) => {
        const dateRange = params.start_date && params.end_date ? params : getDateRange();
        return {
          url: "/statistics/auth",
          params: dateRange,
        };
      },
      transformErrorResponse: (error: any) => error.data.apierror,
    }),
    exportReport: builder.mutation<any, { start_date?: string; end_date?: string }>({
      query: (params = {}) => {
        const dateRange = params.start_date && params.end_date ? params : getDateRange();
        return {
          url: "/statistics/auth/export-pdf",
          params: dateRange,
        };
      },
      transformErrorResponse: (error: any) => error.data.apierror,
    }),
  }),
});

export const { useGetReportsQuery, useLazyGetReportsQuery, useGetStatisticsQuery, useLazyGetStatisticsQuery } =
  reportsApi;
